import { Container } from '@tryhackme/thm-ui-components';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTrackEventMutation } from 'src/common/slices/analytics';
import { BookNowModal } from 'src/features/business/landing-page/components';
import GoogleLogo from 'src/images/pngs/soc-sim/google.png';
import KpmgLogo from 'src/images/pngs/soc-sim/kpmg.png';
import NetworkIcon from 'src/images/pngs/soc-sim/network.png';
import SSandCLogo from 'src/images/pngs/soc-sim/ssc-logo-white.png';
import ThreatlockerLogo from 'src/images/svgs/soc-sim/threatlocker.svg';
import { StyledButton, StyledButtonsContainer, StyledCompanyImage, StyledContent, StyledContentWrapper, StyledContentWrapperOuter, StyledCTASection, StyledDescription, StyledHeading, StyledLogoContainer, StyledLogoTrack, StyledSubheading } from './cta-section.styles';
export const CTASection = () => {
  const navigate = useNavigate();
  const [isBookNowOpen, setIsBookNowOpen] = useState(false);
  const [trackEvent] = useTrackEventMutation();
  const handleBuyNow = () => {
    trackEvent({
      event: 'click-buy-now-b2b'
    });
    navigate('/business/checkout?ref=b2b-home-page');
  };
  const handleBookDemo = () => {
    trackEvent({
      event: 'click-book-demo'
    });
    setIsBookNowOpen(true);
  };
  return <>
      <StyledCTASection data-sentry-element="StyledCTASection" data-sentry-source-file="cta-section.tsx">
        <Container data-sentry-element="Container" data-sentry-source-file="cta-section.tsx">
          <StyledContentWrapperOuter data-sentry-element="StyledContentWrapperOuter" data-sentry-source-file="cta-section.tsx">
            <StyledContentWrapper data-sentry-element="StyledContentWrapper" data-sentry-source-file="cta-section.tsx">
              <StyledContent data-sentry-element="StyledContent" data-sentry-source-file="cta-section.tsx">
                <StyledHeading data-sentry-element="StyledHeading" data-sentry-source-file="cta-section.tsx">Get started with the Business plan today</StyledHeading>

                <StyledSubheading data-sentry-element="StyledSubheading" data-sentry-source-file="cta-section.tsx">
                  Trusted by 1,000+ teams to sharpen security
                  <br />
                  skills and reduce real-world risk
                </StyledSubheading>

                <StyledDescription data-sentry-element="StyledDescription" data-sentry-source-file="cta-section.tsx">
                  Built for every security team, TryHackMe delivers hands-on labs that adapt to your needs and scale
                  with your organisation.
                </StyledDescription>

                <StyledButtonsContainer data-sentry-element="StyledButtonsContainer" data-sentry-source-file="cta-section.tsx">
                  <StyledButton variant="primary" onClick={handleBookDemo} data-sentry-element="StyledButton" data-sentry-source-file="cta-section.tsx">
                    Try for FREE
                  </StyledButton>
                  <StyledButton variant="secondary" onClick={handleBuyNow} data-sentry-element="StyledButton" data-sentry-source-file="cta-section.tsx">
                    Buy now
                  </StyledButton>
                </StyledButtonsContainer>
              </StyledContent>

              <StyledLogoContainer data-sentry-element="StyledLogoContainer" data-sentry-source-file="cta-section.tsx">
                <StyledLogoTrack data-sentry-element="StyledLogoTrack" data-sentry-source-file="cta-section.tsx">
                  {/* First set of logos */}
                  <StyledCompanyImage src={GoogleLogo} alt="Google" data-sentry-element="StyledCompanyImage" data-sentry-source-file="cta-section.tsx" />
                  <StyledCompanyImage src={KpmgLogo} alt="KPMG" data-sentry-element="StyledCompanyImage" data-sentry-source-file="cta-section.tsx" />
                  <StyledCompanyImage src={SSandCLogo} alt="SS&C" data-sentry-element="StyledCompanyImage" data-sentry-source-file="cta-section.tsx" />
                  <StyledCompanyImage src={NetworkIcon} alt="Network Intelligence" data-sentry-element="StyledCompanyImage" data-sentry-source-file="cta-section.tsx" />
                  <StyledCompanyImage src={ThreatlockerLogo} alt="ThreatLocker" data-sentry-element="StyledCompanyImage" data-sentry-source-file="cta-section.tsx" />
                  {/* Duplicate set for infinite scroll */}
                  <StyledCompanyImage src={GoogleLogo} alt="Google" data-sentry-element="StyledCompanyImage" data-sentry-source-file="cta-section.tsx" />
                  <StyledCompanyImage src={KpmgLogo} alt="KPMG" data-sentry-element="StyledCompanyImage" data-sentry-source-file="cta-section.tsx" />
                  <StyledCompanyImage src={SSandCLogo} alt="SS&C" data-sentry-element="StyledCompanyImage" data-sentry-source-file="cta-section.tsx" />
                  <StyledCompanyImage src={NetworkIcon} alt="Network Intelligence" data-sentry-element="StyledCompanyImage" data-sentry-source-file="cta-section.tsx" />
                  <StyledCompanyImage src={ThreatlockerLogo} alt="ThreatLocker" data-sentry-element="StyledCompanyImage" data-sentry-source-file="cta-section.tsx" />
                </StyledLogoTrack>
              </StyledLogoContainer>
            </StyledContentWrapper>
          </StyledContentWrapperOuter>
        </Container>
      </StyledCTASection>
      <BookNowModal open={isBookNowOpen} onOpenChange={setIsBookNowOpen} title="Try for FREE" description="Enter your details to book a demo. We'll be in touch to schedule a time." data-sentry-element="BookNowModal" data-sentry-source-file="cta-section.tsx" />
    </>;
};